import { IconRatingStar } from "@repo/assets/images";
const ReviewCountSkeleton = () => {
  return <div className="mb-3 flex animate-pulse items-end space-x-3 rtl:space-x-reverse" data-sentry-component="ReviewCountSkeleton" data-sentry-source-file="ReviewCountSkeleton.jsx">
      <div className="flex items-center justify-center space-x-3 rtl:space-x-reverse">
        {/* Star SVG - using the same SVG but with gray fill */}
        <IconRatingStar className="text-gray-300" data-sentry-element="IconRatingStar" data-sentry-source-file="ReviewCountSkeleton.jsx" />
        {/* Rating number skeleton */}
        <div className="h-6 w-[25px] rounded bg-gray-300"></div>
      </div>
      {/* Reviews text skeleton */}
      <div className="h-6 w-[70px] rounded bg-gray-300"></div>
    </div>;
};
export default ReviewCountSkeleton;